// H5 system module routes.
import type { RouteRecordRaw } from "vue-router";

export const systemRoutes: RouteRecordRaw[] = [
  {
    path: "/settings/language",
    name: "language",
    component: () => import("@/modules/system/pages/LanguagePage.vue"),
  },
  {
    path: "/notifications",
    name: "notifications",
    component: () => import("@/modules/system/pages/NotificationsPage.vue"),
  },
  {
    // Catch-all. Without it an unknown path matched nothing and the shell
    // rendered no component at all, which is a blank page rather than a state
    // the visitor can read and recover from. Last in the table so it only wins
    // when nothing else matched.
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("@/modules/system/pages/NotFoundPage.vue"),
  },
];
